import { render, staticRenderFns } from "./SecondsToMinutes.vue?vue&type=template&id=06456fea"
import script from "./SecondsToMinutes.vue?vue&type=script&lang=js"
export * from "./SecondsToMinutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports